import ReactTooltip from "react-tooltip";
import { InformationCircleIcon } from "@heroicons/react/24/outline";

export const BalanceSheetCapitalRow = ({
    label,
    value,
    tooltipText,
}) => {
    return (
        <div className="flex items-center justify-between rounded-lg bg-white p-4 shadow-sm border">
            <div className="flex items-center gap-1">
                <span className="text-sm font-medium text-gray-700">
                    {label || ""}
                </span>
                {tooltipText && (
                    <>
                        <InformationCircleIcon
                            className="h-4 w-4 text-gray-500"
                            data-tip={true}
                            data-for={`${label}_tooltip`}
                        />
                        <ReactTooltip
                            id={`${label}_tooltip`}
                            html={true}
                            effect="solid"
                            place="bottom"
                            className="text-xs normal-case"
                        >
                            {tooltipText || ""}
                        </ReactTooltip>
                    </>
                )}
            </div>
            <span className="font-semibold tabular-nums text-gray-900">
                {value || "-"}
            </span>
        </div>
    )
}